import {useFilterByLicense} from '@/biz/license.jsx'

export default () => {
    const filterByLicense = useFilterByLicense()

    return filterByLicense('M00030005', {
        title: '资源库',

        children: [
            {
                title: '模型资源库',
                to: ['/ModelResourceLibrary'],
            },

            {
                title: '模件组资源库',
                to: ['/BizComponentTemplateLibrary'],
            },

            {
                title: '制品模板库',
                to: ['/DesignProductTemplateLibrary'],
            },

            {
                title: '模件生成记录',
                to: ['/BctRecord'],
            },
        ],
    })
}
